import to from 'await-to-js';
import OKA from '../';
import { formatRequest } from '@libs/discovery';
import _get from 'lodash/get';
import config from '@root/config';
import { facetFilterQms } from '../../helpers/constant';

export default {
    Validate: (data) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.post('/queue/validate', {
            ...data
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    CreateQueue: (data) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.post('/queue', {
            ...data
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    QueueDetail: (queueToken) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const apiUrl = queueToken.includes("uq-") ? `/universal-queue/detail/${queueToken}` : `/queue/detail/${queueToken}`;
        const [err, response] = await to(OKA.http.qms.get(apiUrl));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    JsonForm: (facilityId, params = {}) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.get(`/form/${facilityId}`, { params }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    FindPatient: async(params = {}) => {
        if (!OKA.http.qms) return {};
        const [err, response] = await to(OKA.http.qms.get('/patient/search', { params }));
        if (err) {
            return err;
        }
        return response;
    },
    CheckinPatient: (facilityId, params = {}) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.post(`/queue/${facilityId}/patient-arrived`, { ...params }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    SearchPatientForm: async(facilityId, params = {}) => {
        let res = {};
        if (OKA.http.qms) {
            const [err, response] = await to(OKA.http.qms.get(`/form/${facilityId}/search-patient`, { params }));
            if (err) res = err;
            else res = response;
        }

        return res;
    },
    ChoosePaymentMethod: async({ queueToken, paymentMethod }) => {
        if (!OKA.http.qms) return {};
        const [err, response] = await to(OKA.http.qms.post(`/queue/payment/choose`, {
            queue_token: queueToken,
            registration_payment_method: paymentMethod
        }))

        if (err) {
            throw err;
        }
        return response;
    },
    GetPaymentMethods: async({ queueToken, facilityId }) => {
        if (!OKA.http.qms) throw new Error("No");
        const [err, response] = await to(OKA.http.qms.get(`/facility/${facilityId}/payment-method`, {
            params: {
                queue_token: queueToken
            }
        }));

        if (err) {
            throw err;
        }

        return response;
    },
    GetInitialData: (facility) => new Promise(async(resolve, reject) => {
        if (!OKA.http.discovery) reject(false);
        let query = {
            "hitsPerPage": 100,
            "page": 1,
            "analytics": false,
            "attributesToRetrieve": "*",
            "getRankingInfo": true,
            "responseFields": "*",
            "facets": [
                "locations.id",
                "countryCode",
                "gender",
                "languages",
                "locations.area",
                "locations.idx",
                "locations.insuranceLocal.name",
                "locations.insuranceLocal.plans",
                "plan",
                "published",
                "searchSpec",
                "speciality",
                "speciality_title",
                "verified"
            ],
            "facetFilters": [
                ['plan:2'],
                ['published:true'],
                ['locations.fg_queue:true'],
            ],
            nestedFilters: [],
        };
        query.facetFilters.unshift([`locations.id:${facility}`]);
        query = { ...query, nestedFilters: `[${facetFilterQms(facility).nestedFilters}]` };

        let [err, response] = await to(OKA.http.qms.post(`/search/indexes/${config.doctor_index}/query`, {
            params: formatRequest(query)
        }));
        if (err) {
            reject(err);
        } else {
            const data = _get(response, 'data') || false;
            resolve({
                data
            });
        }

    }),
    UpdateAppointmentStatus: (queueToken, dob) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.post('/queue/confirm', {
            queue_token: queueToken,
            dob: dob
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    }),
    AppointmentCancel: (queueToken, dob) => new Promise(async(resolve, reject) => {
        if (!OKA.http.qms) reject(false);
        const [err, response] = await to(OKA.http.qms.post('/queue/cancel', {
            queue_token: queueToken,
            dob: dob
        }));
        if (err) {
            reject(err)
        }

        resolve(response);
    })
};